import c from "../../utils/constants";
import common from "../../utils/common";
import FilterHelper from "../../utils/filter-helper";

const FilterService = function (EventsService, NavigationService) {
  "ngInject"

  const filterType = FilterHelper.filterType;

  const _usersFilterOptions = FilterHelper.usersFilterOptions;

  const _profilesFilterOptions = FilterHelper.profilesFilterOptions;

  const _mediaFilterOptions = FilterHelper.mediaFilterOptions;

  const _surveyFilterOptions = FilterHelper.surveyFilterOptions;

  const _certificatesFilterOptions = FilterHelper.certificatesFilterOptions;

  const _checksFilterOptions = FilterHelper.checksFilterOptions;

  const _jobsFilterOptions = FilterHelper.jobsFilterOptions;

  const _jobRequestsFilterOptions = FilterHelper.jobRequestsFilterOptions;

  const _affiliatesFilterOptions = FilterHelper.affiliatesFilterOptions;

  const _vouchesFilterOptions = FilterHelper.vouchesFilterOptions;

  const _botManagerFilterOptions = FilterHelper.botManagerFilterOptions;

  const _botSessionsFilterOptions = FilterHelper.botSessionsFilterOptions;

  const _businessesFilterOptions = FilterHelper.businessesFilterOptions;

  const _globalUsersFilterOptions = FilterHelper.globalUsersFilterOptions;

  const _globalJobsFilterOptions = FilterHelper.globalJobsFilterOptions;

  const _globalJobsRequestsFilterOptions = FilterHelper.globalJobRequestsFilterOptions;

  const _globalCertificatesFilterOptions = FilterHelper.globalCertificatesFilterOptions;

  const _globalCheckssFilterOptions = FilterHelper.globalChecksFilterOptions;

  const _globalAffiliatesFilterOptions = FilterHelper.globalAffiliatesFilterOptions;

  const _globalBotManagerFilterOptions = FilterHelper.globalBotManagerFilterOptions;

  const _globalVouchesFilterOptions = FilterHelper.globalVouchesFilterOptions;

  const _globalBotSessionsFilterOptions = FilterHelper.globalBotSessionsFilterOptions;

  const _globalBusinessesFilterOptions = FilterHelper.globalBusinessesFilterOptions;

  let _filterExpression = {};

  const generateFilterExpression = (filters) => {
    _filterExpression = {
      logic: 'and',
      filters: []
    };

    for (let i = 0; i < filters.length; i++) {

      let filterItem = filters[i];

      if (filterItem.isActive && (filterItem.value || (filterItem.field === "gender" && filterItem.value === 0))) {
        let filter;

        if (filterItem.filterType == filterType.FREE_TEXT) {
          var value = filterItem.value;
          if (filterItem.field == "userId" || filterItem.field == "userNumberOfJobPosts") value = parseInt(value);

          filter = {
            field: filterItem.field,
            operator: filterItem.filterIitems[filterItem.filterItemSelected].operator,
            value: value
          }
        } else if (filterItem.filterType == filterType.DROP_DOWN) {
          filter = {
            field: filterItem.field,
            operator: "eq",
            value: filterItem.value
          }
        } else if (filterItem.filterType == filterType.DATE_PICKER) {
          filter = {
            field: filterItem.field,
            operator: filterItem.filterIitems[filterItem.filterItemSelected].operator,
            value: common.converToUtcDate(filterItem.value)
          }
        }

        _filterExpression.filters.push(filter);
      }

    }

    console.log("_filterExpression", _filterExpression);
  }

  const getAppliedFilters = () => {
    return _filterExpression;
  }


  // Get global filter options

  const getGlobalUsersFilterOptions = () => _globalUsersFilterOptions

  const getGlobalJobsFilterOptions = () => _globalJobsFilterOptions

  const getGlobalJobRequestsFilterOptions = () => _globalJobsRequestsFilterOptions

  const getGlobalAffiliatesFilterOptions = () => _globalAffiliatesFilterOptions

  const getGlobalVocuhesFilterOptions = () => _globalVouchesFilterOptions

  const getGlobalCertificatesFilterOptions = () => _globalCertificatesFilterOptions

  const getGlobalCheckssFilterOptions = () => _globalCheckssFilterOptions

  const getGlobalBotManagerFilterOptions = () => _globalBotManagerFilterOptions

  const getGlobalBotSessionsFilterOptions = () => _globalBotSessionsFilterOptions

  const getGlobalBusinessesFilterOptions = () => _globalBusinessesFilterOptions

  ////////////



  const getUsersFilterOptions = (globaFilterType) => {

    switch (globaFilterType) {
      case c.globalUsersFilterTypes.PAYG_USERS:
        return _applyPAYGModifier(_usersFilterOptions);
      case c.globalUsersFilterTypes.ALL_PAYING_USERS:
        return _applyPayingSinceModifier(_usersFilterOptions);
      case c.globalUsersFilterTypes.NSW_CUSTOMERS:
        return _applyNSWModifier(_usersFilterOptions);
      case c.globalUsersFilterTypes.VIC_CUSTOMERS:
      return _applyVICModifier(_usersFilterOptions);
      case c.globalUsersFilterTypes.ALL_USERS:
        return _resetFilterOptions(_usersFilterOptions);
      default:
        return _usersFilterOptions;
    }
  }

  const getBusinessesFilterOptions = (globalFilterType) => {
    switch (globalFilterType) {
      case c.globalBusinessesFilterTypes.NSW_BUSINESSES:
        return _applyNSWBusinessModifier(_businessesFilterOptions);
        case c.globalBusinessesFilterTypes.VIC_BUSINESSES:
          return _applyVICBusinessModifier(_businessesFilterOptions);
      default:
        return _businessesFilterOptions;
    }
  }

  const getProfilesFilterOptions = (globaFilterType) => {

    switch (globaFilterType) {
      default:
        return _profilesFilterOptions;
    }
  }

  const getMediaFilterOptions = () => _mediaFilterOptions;

  const getSurveyFilterOptions = () => _surveyFilterOptions;

  const getCertificatesFilterOptions = (globalFilterType) => {
    switch(globalFilterType) {
      case c.globalCertificatesFilterTypes.PENDING_VERIFICATION:
        return _applyPendingVerificationCertificatesModifier(_certificatesFilterOptions);
      case c.globalCertificatesFilterTypes.ALL_CERTIFICATES:
        return _resetFilterOptions(_certificatesFilterOptions);
      default:
        return _certificatesFilterOptions;
    }
  }

  const getChecksFilterOptions = (globalFilterType) => {
    switch(globalFilterType) {
      case c.globalChecksFilterTypes.ALL_CHECKS:
        return _resetFilterOptions(_checksFilterOptions);
      default:
        return _checksFilterOptions;
    }
  }

  const getJobsFilterOptions = (globaFilterType) => {
    switch(globaFilterType) {
      case c.globalJobsFilterTypes.ALL_JOBS:
        return _resetFilterOptions(_jobsFilterOptions);
      case c.globalJobsFilterTypes.JOBS_POSTED_TODAY:
        return _applyJobsPostedTodayModifier(_jobsFilterOptions);
      case c.globalJobsFilterTypes.JOBS_EXPIRE_TODAY:
        return _applyJobsExpireTodayModifier(_jobsFilterOptions);
      case c.globalJobsFilterTypes.RECURRING_JOB_POSTED_15_DAYS_AGO:
        return _applyRecurringJobsPosted15DaysAgoModifier(_jobsFilterOptions);
      default:
        return _jobsFilterOptions;
    }

  }

  const getJobRequestsFilterOptions = (globaFilterType) => {
    switch(globaFilterType) {
      case c.globalJobRequestsFilterTypes.ALL_JOB_REQUESTS:
        return _resetFilterOptions(_jobRequestsFilterOptions);
      default:
        return _jobRequestsFilterOptions;
    }

  }

  const _applyEmployeeBenefitsModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "affiliateSource") {
        optionModified = Object.assign({}, option, { isActive: true, value: 2 });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyReferralModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "affiliateSource") {
        optionModified = Object.assign({}, option, { isActive: true, value: 1 });
      } else if (option.field == "affiliateStatus") {
        optionModified = Object.assign({}, option, { isActive: true, value: 2 });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const getAffiliatesFilterOptions = (globaFilterType) => {
    switch(globaFilterType) {
      case c.globalAffiliatesFilterTypes.ALL_AFFILIATES:
        return _resetFilterOptions(_affiliatesFilterOptions);
      case c.globalAffiliatesFilterTypes.EMPLOYEE_BENEFITS:
        return _applyEmployeeBenefitsModifier(_affiliatesFilterOptions);
      case c.globalAffiliatesFilterTypes.REFERRALS:
        return _applyReferralModifier(_affiliatesFilterOptions);
      default:
        return _affiliatesFilterOptions;
    }
  }

  const getVouchesFilterOptions = (globaFilterType) => {
    switch(globaFilterType) {
      case c.globalVouchesFilterTypes.ALL_VOUCHES:
        return _resetFilterOptions(_vouchesFilterOptions);
      default:
        return _vouchesFilterOptions;
    }
  }

  const getbotManagerFilterOptions = (globaFilterType) => {
    switch(globaFilterType) {
      case c.globalBotManagerFilterTypes.ALL_BOT_FLOWS:
        return _resetFilterOptions(_botManagerFilterOptions);
      default:
        return _botManagerFilterOptions;
    }
  }


  const getbotSessionsFilterOptions = (globaFilterType) => {
    switch(globaFilterType) {
      case c.globalBotSessionsFilterTypes.ALL_BOT_SESSIONS:
        return _resetFilterOptions(_botSessionsFilterOptions);
      default:
        return _botSessionsFilterOptions;
    }
  }


  // Global filter modifiers

  const _applyPAYGModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "membershipTypeName") {
        optionModified = Object.assign({}, option, { isActive: true, value: "PayAsYouGo" });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyPayingSinceModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "paymentInfo.payingMemberSince") {
        optionModified = Object.assign({}, option, { isActive: true, value: 1 });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyNSWModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "addresses.state") {
        optionModified = Object.assign({}, option, { isActive: true, value: 'nsw' });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyVICModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "addresses.state") {
        optionModified = Object.assign({}, option, { isActive: true, value: 'vic' });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyPendingVerificationCertificatesModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "accountStatus") {
        optionModified = Object.assign({}, option, { isActive: true, value: 1 });
      } else if (option.field == "certificateStatus") {
        optionModified = Object.assign({}, option, { isActive: true, value: 1 });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyJobsPostedTodayModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "postDate") {
        optionModified = Object.assign({}, option, { isActive: true, value: common.converToUtcDate(new Date()), filterItemSelected: 1 });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyJobsExpireTodayModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "expiresInDays") {
        optionModified = Object.assign({}, option, { isActive: true, value: 1, filterItemSelected: 1 });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyRecurringJobsPosted15DaysAgoModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "postDate") {
        optionModified = Object.assign({}, option, { isActive: true, value: common.subtractDays(new Date(), 15), filterItemSelected: 1 });
      } else if (option.field == "jobType") {
        optionModified = Object.assign({}, option, { isActive: true, value: 14, filterItemSelected: 2 });
      } else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyNSWBusinessModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "state") {
        optionModified = Object.assign({}, option, { isActive: true, value: 'nsw' });
      } else if (option.field == "locationType") {
        optionModified = Object.assign({}, option, { isActive: true, value: c.locationType.CENTRE_BASED_DAYCARE });
      } else if (option.field == "helpersCount") {
        optionModified = Object.assign({}, option, { isActive: true, value: 100, filterItemSelected: 3 });
      }else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _applyVICBusinessModifier = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified;
      if (option.field == "state") {
        optionModified = Object.assign({}, option, { isActive: true, value: 'vic' });
      } else if (option.field == "locationType") {
        optionModified = Object.assign({}, option, { isActive: true, value: c.locationType.CENTRE_BASED_DAYCARE });
      } else if (option.field == "helpersCount") {
        optionModified = Object.assign({}, option, { isActive: true, value: 100, filterItemSelected: 3 });
      }else {
        optionModified = Object.assign({}, option, { isActive: false });
      }

      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  const _resetFilterOptions = (filterOptions) => {
    let modifiedFilter = filterOptions.map((option) => {
      let optionModified = Object.assign({}, option, { isActive: false });
      return optionModified;
    })
    console.log("Modified Filter", modifiedFilter)
    return modifiedFilter;
  }

  return {
    generateFilterExpression,
    getAppliedFilters,
    getUsersFilterOptions,
    getProfilesFilterOptions,
    getMediaFilterOptions,
    getSurveyFilterOptions,
    getCertificatesFilterOptions,
    getChecksFilterOptions,
    getJobsFilterOptions,
    getAffiliatesFilterOptions,
    getVouchesFilterOptions,
    getbotManagerFilterOptions,
    getbotSessionsFilterOptions,
    getGlobalUsersFilterOptions,
    getGlobalJobsFilterOptions,
    getGlobalAffiliatesFilterOptions,
    getGlobalVocuhesFilterOptions,
    getGlobalCertificatesFilterOptions,
    getGlobalCheckssFilterOptions,
    getGlobalBotManagerFilterOptions,
    getGlobalBotSessionsFilterOptions,
    getGlobalBusinessesFilterOptions,
    getBusinessesFilterOptions,
    getJobRequestsFilterOptions,
    getGlobalJobRequestsFilterOptions,
  }
};

export default FilterService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/filter.service.js
 **/